import {
  countryConstants,
  warehouseConstants,
  shippingCompanyConstants,
  priceConstants,
  shippingCategoryConstants,
} from "../actions/constants";

const initialState = {
  countries: [],
  warehouses: [],
  companies: [],
  prices: [],
  shippingCategories: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

export default function shippingReducer(state = initialState, action) {
  switch (action.type) {
    // ─── Country ────────────────────────────────────────────────────────────
    case countryConstants.GET_COUNTRIES_REQUEST:
    case countryConstants.CREATE_COUNTRY_REQUEST:
    case countryConstants.UPDATE_COUNTRY_REQUEST:
    case countryConstants.DELETE_COUNTRY_REQUEST:
      return { ...state, loading: true, error: null };

    case countryConstants.GET_COUNTRIES_SUCCESS:
      return { ...state, loading: false, countries: action.payload.countries };

    case countryConstants.CREATE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: [...state.countries, action.payload.country],
      };

    case countryConstants.UPDATE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: state.countries.map((c) =>
          c.id === action.payload.country.id ? action.payload.country : c,
        ),
      };

    case countryConstants.DELETE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: state.countries.filter((c) => c.id !== action.payload.id),
      };

    case countryConstants.GET_COUNTRIES_FAILURE:
    case countryConstants.CREATE_COUNTRY_FAILURE:
    case countryConstants.UPDATE_COUNTRY_FAILURE:
    case countryConstants.DELETE_COUNTRY_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    // ─── Warehouse ──────────────────────────────────────────────────────────
    case warehouseConstants.GET_WAREHOUSES_REQUEST:
    case warehouseConstants.CREATE_WAREHOUSE_REQUEST:
    case warehouseConstants.UPDATE_WAREHOUSE_REQUEST:
    case warehouseConstants.DELETE_WAREHOUSE_REQUEST:
      return { ...state, loading: true, error: null };

    case warehouseConstants.GET_WAREHOUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouses: action.payload.warehouses,
      };

    case warehouseConstants.CREATE_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouses: [...state.warehouses, action.payload.warehouse],
      };

    case warehouseConstants.UPDATE_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouses: state.warehouses.map((w) =>
          w.id === action.payload.warehouse.id ? action.payload.warehouse : w,
        ),
      };

    case warehouseConstants.DELETE_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouses: state.warehouses.filter((w) => w.id !== action.payload.id),
      };

    case warehouseConstants.GET_WAREHOUSES_FAILURE:
    case warehouseConstants.CREATE_WAREHOUSE_FAILURE:
    case warehouseConstants.UPDATE_WAREHOUSE_FAILURE:
    case warehouseConstants.DELETE_WAREHOUSE_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    // ─── Shipping Company ───────────────────────────────────────────────────
    case shippingCompanyConstants.GET_SHIPPING_COMPANIES_REQUEST:
    case shippingCompanyConstants.CREATE_SHIPPING_COMPANY_REQUEST:
    case shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_REQUEST:
    case shippingCompanyConstants.DELETE_SHIPPING_COMPANY_REQUEST:
      return { ...state, loading: true, error: null };

    case shippingCompanyConstants.GET_SHIPPING_COMPANIES_SUCCESS:
      return { ...state, loading: false, companies: action.payload.companies };

    case shippingCompanyConstants.CREATE_SHIPPING_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: [...state.companies, action.payload.company],
      };

    case shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: state.companies.map((c) =>
          c.id === action.payload.company.id ? action.payload.company : c,
        ),
      };

    case shippingCompanyConstants.DELETE_SHIPPING_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: state.companies.filter((c) => c.id !== action.payload.id),
      };

    case shippingCompanyConstants.GET_SHIPPING_COMPANIES_FAILURE:
    case shippingCompanyConstants.CREATE_SHIPPING_COMPANY_FAILURE:
    case shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_FAILURE:
    case shippingCompanyConstants.DELETE_SHIPPING_COMPANY_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    // ─── Price ──────────────────────────────────────────────────────────────
    case priceConstants.GET_PRICES_REQUEST:
    case priceConstants.CREATE_PRICE_REQUEST:
    case priceConstants.UPDATE_PRICE_REQUEST:
    case priceConstants.DELETE_PRICE_REQUEST:
      return { ...state, loading: true, error: null };

    case priceConstants.GET_PRICES_SUCCESS:
      return { ...state, loading: false, prices: action.payload.prices };

    case priceConstants.CREATE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        prices: [...state.prices, action.payload.price],
      };

    case priceConstants.UPDATE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        prices: state.prices.map((p) =>
          p.id === action.payload.price.id ? action.payload.price : p,
        ),
      };

    case priceConstants.DELETE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        prices: state.prices.filter((p) => p.id !== action.payload.id),
      };

    case priceConstants.GET_PRICES_FAILURE:
    case priceConstants.CREATE_PRICE_FAILURE:
    case priceConstants.UPDATE_PRICE_FAILURE:
    case priceConstants.DELETE_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    // ─── Shipping Category ──────────────────────────────────────────────────
    case shippingCategoryConstants.GET_SHIPPING_CATEGORIES_REQUEST:
    case shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_REQUEST:
    case shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_REQUEST:
    case shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };

    case shippingCategoryConstants.GET_SHIPPING_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingCategories: action.payload.shippingCategories,
        pagination: action.payload.pagination,
      };

    case shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingCategories: [
          ...state.shippingCategories,
          action.payload.shippingCategory,
        ],
      };

    case shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingCategories: state.shippingCategories.map((sc) =>
          sc.id === action.payload.shippingCategory.id
            ? action.payload.shippingCategory
            : sc,
        ),
      };

    case shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingCategories: state.shippingCategories.filter(
          (sc) => sc.id !== action.payload.id,
        ),
      };

    case shippingCategoryConstants.GET_SHIPPING_CATEGORIES_FAILURE:
    case shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_FAILURE:
    case shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_FAILURE:
    case shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    default:
      return state;
  }
}
